module.exports = __webpack_public_path__ + "img/mail.29b4a502.png";